module.exports = __webpack_public_path__ + "img/preview.2c91486a.png";